import { z } from "zod"

export const schema = z.object({
    articleNumber: z.string().optional(),
    description: z.string().trim().min(1),
    purchasePrice: z.number().optional(),
    retailPrice: z.number().optional(),
    isDefaultForCategory: z.boolean().optional(),
    vatType: z.number().gt(0),
    note: z.string().optional(),
})
